// Dos reglas sobre valores que usa el formulario, aparte para poder probarlas sin
// React (#79): qué cuenta como vacío para un obligatorio, y cómo se comparan dos
// etiquetas.

/** Vacío para un obligatorio: nada, solo espacios, o una lista sin elementos. */
export function vacio(valor: unknown): boolean {
  if (valor === undefined || valor === null) return true;
  if (typeof valor === 'string') return valor.trim() === '';
  if (Array.isArray(valor)) return valor.length === 0;
  return false;
}

/**
 * Cómo se comparan dos etiquetas: sin mayúsculas ni tildes, como las compara la
 * API al guardar. `NFD` separa cada letra de su tilde y el `replace` quita las
 * tildes sueltas.
 */
export const clave = (texto: string) =>
  texto
    .normalize('NFD')
    .replace(/\p{Mn}/gu, '')
    .toLowerCase();
